import React from 'react';

import { GameScoreModel } from '../../models/gameScoreModel';
import GameScore from './GameScore';
import useSorting from '../shared/Sorting/useSorting';
import Sorting from '../shared/Sorting/Sorting';
import createSortBy, { DEFAULT_SORT } from '../shared/Sorting/utils';
import './GameScores.scss';

const sortOptions = [{
  optionText: 'Latest',
  optionValue: '-createdAt',
}, {
  optionText: 'Oldest',
  optionValue: 'createdAt',
}, {
  optionText: 'Highest',
  optionValue: '-score',
}, {
  optionText: 'Lowest',
  optionValue: 'score',
}];

interface Props {
  gameScores: GameScoreModel[];
}

const GameScores = ({ gameScores }: Props): React.ReactElement => {
  const { sortBy } = useSorting();

  gameScores.sort(createSortBy(sortBy || DEFAULT_SORT));

  return (
    <div className="game-scores">
      <div className="sorting-container">
        <Sorting sortOptions={sortOptions} />
      </div>

      <div className="scores list">
        {
          gameScores.map((score) => (
            <div key={score.id} className="list-item">

              <GameScore gameScore={score} />
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default GameScores;
